enum DonationCampaignStatus {
  Submitted = 'Submitted',
  Approved = 'Approved',
  Active = 'Active',
  Closed = 'Closed',
  Expired = 'Expired',
  Rejected = 'Rejected',
}
export default DonationCampaignStatus;
